import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import {ScreenshotIcon} from "../../common/icons";
import COLOR_THEMES from "../../../colorThemes";
import {changeSqftFeaturesPopup, setAPIErrorMessage, setSqftCabinetsGlb} from "../../../actions/sqftFunctions";
import {setSQFTAr3dPopup} from "../../../actions/sqftMenuFunctions";
import SqftStore from "../../sqft/components/canvas/store/sqftStore";

export const SqftFeaturesPopupSaveImageButton = (props) => {
  const {activeTheme, isMobile} = props;

  const SaveImageButtonClick = async () => {
    if (SqftStore.viewGL && SqftStore.viewGL.renderer) {
      const imageDataURL = SqftStore.viewGL.renderer.domElement.toDataURL("image/jpeg");
      const link = document.createElement('a');
      link.href = imageDataURL;
      link.download = 'scene.jpg';
      document.body.appendChild(link); // Добавление ссылки к документу
      link.click(); // Имитация клика по ссылке для начала скачивания
      document.body.removeChild(link); // Удаление ссылки после скачивания
    }
  }
  const screenshotIconStyle = isMobile ? { marginLeft: "13px", marginTop: "7px"} : { marginLeft: "5px", marginTop: "5px"}

  return (
    <Button className={"ui-button2 ui-button2--primary-border"}
            startIcon={(
              <SvgIcon style={screenshotIconStyle}>
                <ScreenshotIcon color={ COLOR_THEMES[activeTheme].primary } />
              </SvgIcon>
            )}
            onClick={() => SaveImageButtonClick()}>
      {
        isMobile ? "" : <FormattedMessage id="sqft.popup.button.save3dImage"/>
      }
    </Button>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
    cabinetsGlb: store.sqftState.cabinetsGlb,
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = {
  setSqftCabinetsGlb,
  setSQFTAr3dPopup,
  changeSqftFeaturesPopup,
  setAPIErrorMessage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupSaveImageButton)
)
